export class Operaicommessa {
  commessaId: number;
  personaId: number;
  constructor(){
    this.commessaId=0;
    this.personaId=0;
  }
}
